var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-col-12"},[_c('div',{staticClass:"card"},[_c('ancestryline-data-table',{ref:"protocollistdatatable",attrs:{"data-function":_vm.dataFunction,"columns":_vm.columns,"quantity-rows":_vm.quantityPerPage,"default-filter":_vm.defaultFilter || _vm.filters}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }